import { Modal } from "@talladega/components";
import { gtmPushData } from "@talladega/helpers";
import useUser from "@modules/user/hooks/useUser";
import { useTranslation } from "next-i18next";
import { ReactNode, useEffect } from "react";

type Props = {
  showUnexpectedErrorModal: boolean;
  setShowUnexpectedErrorModal: (show: boolean) => void;
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
  primaryButtonText: string;
  secondaryButtonText?: string;
  title?: string;
  heading?: string;
  subheading?: string;
  body?: ReactNode;
};

const UnexpectedErrorModal = ({
  showUnexpectedErrorModal,
  setShowUnexpectedErrorModal,
  onPrimaryClick,
  onSecondaryClick,
  primaryButtonText,
  secondaryButtonText,
  title,
  heading,
  subheading,
  body,
}: Props) => {
  const { t } = useTranslation(["common", "purchase"]);
  const { user } = useUser();

  useEffect(() => {
    if (showUnexpectedErrorModal) {
      gtmPushData({
        event: "ICO",
        description: "ICO Unexpected Error",
        element: "ICO Landing Page",
        user_id: user?.id,
      });
    }
  }, [showUnexpectedErrorModal, user?.id]);

  return (
    <Modal
      isOpen={showUnexpectedErrorModal}
      onClose={() => setShowUnexpectedErrorModal(false)}
      title={title ?? t("purchase:something_went_wrong_error")}
      alignment="center"
      buttonDisplay="block"
    >
      <p className="text-xl font-semibold text-primary">
        {heading ?? t("common:oops")}
      </p>
      <p className="mt-2 text-secondary text-lg font-normal">
        {subheading ?? t("purchase:unexpected_error_message")}
      </p>
      <p className="b-2 mt-4 text-base font-normal text-secondary">
        {body ?? t("purchase:please_come_back")}
      </p>

      <Modal.Buttons
        primaryButtonText={primaryButtonText}
        onPrimaryClick={onPrimaryClick}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonFill="link"
        onSecondaryClick={onSecondaryClick}
        stretchButtonToContent
      />
    </Modal>
  );
};

export default UnexpectedErrorModal;
